import { render } from "./index.vue?vue&type=template&id=55be2d9c&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=55be2d9c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55be2d9c"]])

export default __exports__